
<app-stream-page [data]="signalRService.data"></app-stream-page>
 